import { PAGE_INPUT_QUERY_KEY } from '@unifyapps/carbon/no-code/const';
import { createQueryParams } from '@unifyapps/carbon/no-code/utils/createQueryParams';

type Args = {
  pageId: string | undefined;
  pageInputs?: Record<string, unknown>;
};

export const getPagePathname = ({ pageId, pageInputs }: Args) => {
  // If pageId is not present, return undefined
  if (!pageId) {
    return undefined;
  }

  // If pageInputs are present,return pathname with pageInputs as query params
  if (pageInputs) {
    const query = createQueryParams(PAGE_INPUT_QUERY_KEY, pageInputs);
    return `/${pageId}?${query}`;
  }

  // If pageInputs are not present, return pathname without query params
  return `/${pageId}`;
};
